import request from '@/axios/request';
/**
 * 查询用户列表
 * @param {} parameters 
 * @returns 
 */
export const queryUser = (parameters) => {
  return request({
    method: 'post',
    url: '/user/queryByPage',
    data: parameters
  })
}
/**
 * 查看用户
 * @param {} parameters 
 * @returns 
 */
export const queryUserById = (parameters) => {
  return request({
    method: 'post',
    url: '/user/queryById',
    data: parameters
  })
}
/**
 * 授权
 * @param {} parameters 
 * @returns 
 */
export const updateUserRole = (parameters) => {
  return request({
    method: 'post',
    url: '/user/updateUserRole',
    data: parameters
  })
}
/**
 * 禁用/启用
 * @param {} parameters 
 * @returns 
 */
export const updateUserStatus = (parameters) => {
  return request({
    method: 'post',
    url: '/user/updateUserStatus',
    data: parameters
  })
}
/**
 * 登录
 * @param {} parameters 
 * @returns 
 */
export const userLigin = (parameters) => {
  return request({
    method: 'post',
    url: '/login',
    data: parameters,
  })
}
/**
 * 获取二维码
 * @param {*} parameters 
 * @returns 
 */
export const authQrcode = (parameters) => {
  return request({
    method: 'get',
    url: '/auth/qrcode',
    params: parameters,
  })
}
/**检查登录状态
 * 
 */
export const authCheck = (parameters) => {
  return request({
    method: 'get',
    url: '/auth/check',
    params: parameters,
  })
}